<template>
  <div :class="['item-hotel', { horizonal: type === 'horizonal' }]">
    <div class="hotel-cover">
      <img :src="roomThumbnail" alt="demo" />
      <div class="hotel-title">
        <h3>
          <a @click="gotoDetails">
            {{ roomBasicInfo.roomNm }}
          </a>
        </h3>
      </div>
    </div>
    <div class="hotel-content">
      <div class="hotel-title">
        <h3>
          <a @click="gotoDetails">
            {{ roomBasicInfo.roomNm }}
          </a>
        </h3>
      </div>
      <div class="hotel-meta-wrap items-start">
        <div class="hotel-meta">
          <div class="meta-item">
            <i class="icon icon-bor-people" />
            <span>定員 {{ roomBasicInfo.maxStayCapacity }}名</span>
          </div>
          <div class="meta-item">
            <i class="icon icon-bor-bed" />
            <span>{{ roomBasicInfo.roomCondNm }}</span>
          </div>
          <div class="meta-item">
            <i class="icon icon-bor-m2" />
            <span>部屋のサイズ {{ roomBasicInfo.roomSizeTxt }}</span>
          </div>
          <div class="meta-item" v-show="roomBasicInfo.smokingDiv == '1'">
            <i class="icon icon-bor-no-smoking" />
            <span>禁煙</span>
          </div>
          <div class="meta-item" v-show="roomBasicInfo.smokingDiv == '2'">
            <i class="icon icon-bor-no-smoking" />
            <span>喫煙</span>
          </div>
          <div class="meta-item" v-show="roomBasicInfo.smokingDiv == '3'">
            <i class="icon icon-bor-no-smoking" />
            <span>おまかせ</span>
          </div>
        </div>
        <div class="hotel-price" v-bind:class="{ hide: this.isHide }">
          <span>{{ getSymbolPlan }}</span>
          <strong>{{ getPricePlan }}～</strong>
        </div>
      </div>
      <div v-if="type === 'horizonal'" class="room-actions">
        <a-space>
          <button class="c-btn btn-white btn-sm" @click="gotoDetails">
            お部屋の詳細
          </button>
          <button class="c-btn btn-white btn-sm" @click="gotoDetails">
            空室カレンダー
          </button>
        </a-space>
      </div>
      <div v-else class="hotel-actions">
        <button class="c-btn btn-white btn-sm" @click="gotoDetails">
          詳細を見る
        </button>
        <a-tooltip :overlayClassName="getStockPlan" v-model="visible">
          <template slot="title">
            {{ getStockPlan == "tooltip-red" ? "残りわずか" : "空室あり" }}
          </template>
          <button class="c-btn btn-grey btn-sm" @click="gotoDetails(true)">
            予約する
          </button>
        </a-tooltip>
      </div>
    </div>
  </div>
</template>

<script>
import _ from 'lodash'
import moment from 'moment'
import func_utils from '@/mixins/func_utils'
const PLACEHOLDER_IMG = require('@/assets/images/slide-img-placeholder.png')
import { SCROLL_CALENDAR } from '@/store/modules/plan/actions'

export default {
  mixins: [func_utils],
  props: [
    'type',
    'plan',
    'hidePriceProps',
    'numPeople',
    'checkInDay',
    'stayNights'
  ],
  setup() {
    return {}
  },
  data() {
    return {
      roomBasicInfo: {},
      isHide: this.hidePriceProps || false,
      stayDay: moment(new Date()),
      visible: false
    }
  },
  mounted() {
    if (this.plan) {
      this.roomBasicInfo = this.plan.roomBasicInfo || {}
    }

    if (this.checkInDay) {
      this.stayDay = this.checkInDay
    } else {
      this.stayDay = moment(this.stayDay).format('YYYY/MM/DD')
    }

    this.$nextTick(() => {
      this.visible = true
    })
  },
  watch: {
    visible() {
      if (this.visible === false) {
        this.visible = true
      }
    }
  },
  computed: {
    currentDay() {
      return moment(this.checkInDay).format('YYYY/MM/DD')
    },

    roomThumbnail() {
      return _.get(this.roomBasicInfo, 'roomImages[0]', null)
        ? _.get(this.roomBasicInfo, 'roomImages[0]', null)
        : PLACEHOLDER_IMG
    },

    getPricePlan() {
      const calendar =
        _.get(this.plan, 'vacancyCalendar.vacancyCalendars', []).find(
          (calendar) => calendar.stayDay === this.currentDay
        ) || {}
      const price = calendar?.roomPrice ?? calendar?.price
      return this.formatCurrency(price || 0)
    },

    getSymbolPlan() {
      const calendar =
        _.get(this.plan, 'vacancyCalendar.vacancyCalendars', []).find(
          (calendar) => calendar.stayDay === this.currentDay
        ) || {}
      return calendar?.roomPrice != null ? '1泊の料金' : '大人1人'
    },
    getStockPlan() {
      const currentDay = this.stayDay
      const calendar = _.get(
        this.plan,
        'vacancyCalendar.vacancyCalendars',
        []
      ).find((calendar) => calendar.stayDay === currentDay)
      const stock = _.get(calendar, 'stock', 0)
      return stock >= 1 && stock <= 4 ? 'tooltip-red' : 'tooltip-blue'
    }
  },
  methods: {
    gotoDetails(params) {
      const { menuNo } = this.$route.params
      const { adultHeadCnt } = this.$route.query
      const planId = this.roomBasicInfo.planId
      const roomId = this.roomBasicInfo.roomId

      const query = {
        adultHeadCnt: adultHeadCnt || 1
      }

      if (this.checkInDay) {
        query.checkInDate = moment(this.checkInDay).format('YYYY-MM-DD')
      }

      if (this.stayNights) query.stayNights = this.stayNights

      this.$store.dispatch(SCROLL_CALENDAR, params)
      this.$router.push({
        path: `/menus/${menuNo}/plans/${planId}/rooms/${roomId}`,
        query
      })
    }
  }
}
</script>

<style lang="scss" scoped>
@import "./styles.scss";

/deep/ .ant-btn-lg {
  font-weight: 700;
  color: #1f2021;
}
/deep/ .btn-dark {
  background-color: #434547;
  color: #ffffff;
}
</style>

<style lang="scss">
.tooltip-red .ant-tooltip-inner {
  background-color: #da291c;
  color: #ffffff;
}
.tooltip-blue .ant-tooltip-inner {
  background-color: #259bee;
  color: #ffffff;
}
</style>
